import './App.css';
import { useState, useEffect, useRef } from "react";
import React from 'react';
import { MDBIcon } from 'mdb-react-ui-kit';
import ReactFlagsSelect from "react-flags-select";

import ReactCustomFlagSelect from 'react-custom-flag-select';
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import Countdown from 'react-countdown';

function App() {
  const [dataResult, setDataResult] = useState([]);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);
  const inputRef = useRef(null);
  const inputPackage = useRef(null);
  const inputLocation = useRef(null);
  const inputQuantity = useRef(null);
  const inputLenght = useRef(null);
  const inputWide = useRef(null);
  const inputHeight = useRef(null);
  const inputWeight = useRef(null);
  const [listCountry, setCountry] = useState([]);
  const [resultChecking, setResultChecking] = useState();
  const [count, setCount] = useState(1);

  const inputDiscount = useRef(false);
const Ref = useRef(null);
const [timer, setTimer] = useState("00:00:29");
	
  const listCountries = 
    [
  "US",
  "GB",
  "CA",
  "JP",
  "KR",
  "AU",
      "CN","CN1","CN2",
  "AF",
  "AL",
  "DZ",
  "AS",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BR",
  "IO",
  "BG",
  "BF",
  "BI",
  "KH",
  "CM",
  "CV",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "CI",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "PF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GU",
  "GT",
  "GG",
  "GN",
  "GW",
  "HT",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MK",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MH",
  "MQ",
  "MR",
  "MU",
  "MX",
  "FM",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NP",
  "NL",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MP",
  "NO",
  "OM",
  "PK",
  "PW",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "PR",
  "QA",
  "RO:",
  "RU",
  "RW",
  "KN",
  "LC",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "SS",
  "ES",
  "LK",
  "SD",
  "SR",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TG",
  "TK",
  "TO",
  "TT",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VI",
  "YE",
  "ZM",
  "ZW",
];
  

  const showSelectedLabel = true;
  const showSecondarySelectedLabel = true;
  const selectedSize = 16;
  const showOptionLabel = true;
  const showSecondaryOptionLabel = true;
  const optionsSize = 16;
  const placeholder = "";
  const searchable = true;
  const searchPlaceholder = "Search for a country";
  const alignOptionsToRight = false;
  const fullWidth = true;
  const disabled = false;
  
  const queryParameters = new URLSearchParams(window.location.search);
  const packageType = queryParameters.get("packageType");
  const packageArea = queryParameters.get("area");
  const packageToCountry = queryParameters.get("toCountry");
  const packageQuantity = queryParameters.get("quantity");
  const packageLength = queryParameters.get("length");
  const packageWidth = queryParameters.get("width");
  const packageHeight = queryParameters.get("height");
  const packageWeight = queryParameters.get("weight");
  const path = window.location.pathname;
  const pathArray = path.split("/");
  const language = pathArray[1];
  const pathRoute = pathArray[2] !== null && pathArray[2] !== '' ? pathArray[2] : pathArray[1];
  console.log(pathRoute);
  let countPackage = 1;
  
  
  useEffect(() => {
    if (packageType !== null && packageArea !== null && packageToCountry !== null && packageQuantity !== null && packageLength !== null && packageWidth !== null && packageHeight !== null) {
      console.log("Submit Fare Button");
      document.getElementById("checkfareBtn").click();
    }
  }, [listCountry]);
  
  useEffect(() => {
    
    	const addPackageButton = document.querySelector(".themhang");
    	

        addPackageButton.addEventListener("click", function () {
            const rowList = document.querySelector('.row-list');
            const lastRow = rowList.lastElementChild;
          	countPackage = countPackage + 1;

            const newForm = document.createElement("div");
            newForm.className = "row";
            newForm.innerHTML = `
            <div class="col-md-2">
                <div class="form-group">
                    <p><label for="soluong"><b class="sectors-bot">Quantity</b></label><br />
                        <span class="wpcf7-form-control-wrap" data-name="soluong">
                            <input class="wpcf7-form-control wpcf7-number wpcf7-validates-as-required wpcf7-validates-as-number form-control input-style-2"
                                type="number" name="quantity_`+countPackage+`" min="1" />
                        </span>
                    </p>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <p><label for="dai"><b class="sectors-bot">Length (CM)</b></label><br />
                        <span class="wpcf7-form-control-wrap" data-name="dai"><input
                                class="wpcf7-form-control wpcf7-number wpcf7-validates-as-required wpcf7-validates-as-number form-control input-style-2"
                                type="number" name="length_`+countPackage+`" min="1" /></span>
                    </p>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <p><label for="rong"><b class="sectors-bot">Width (CM)</b></label><br />
                        <span class="wpcf7-form-control-wrap" data-name="rong"><input
                                class="wpcf7-form-control wpcf7-number wpcf7-validates-as-required wpcf7-validates-as-number form-control input-style-2"
                                type="number" name="width_`+countPackage+`" min="1" />
                        </span>
                    </p>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <p><label for="cao"><b class="sectors-bot">Height (CM)</b></label><br />
                        <span class="wpcf7-form-control-wrap" data-name="cao"><input
                                class="wpcf7-form-control wpcf7-number wpcf7-validates-as-required wpcf7-validates-as-number form-control input-style-2"
                                type="number" name="height_`+countPackage+`" min="1" /></span>
                    </p>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <p><label for="khoiluong"><b class="sectors-bot">Weight
                                  (KG)</b></label><br />
                        <span class="wpcf7-form-control-wrap" data-name="khoiluong"><input
                                class="wpcf7-form-control wpcf7-number wpcf7-validates-as-required wpcf7-validates-as-number form-control input-style-2"
                                type="number" name="weight_`+countPackage+`" min="0.5" step="0.5" /></span>
                    </p>
                </div>
            </div>
            <div class="col-sm-2">
                <p><button class="delete-form" type="button" ><i class="fa-solid fa-trash-can"></i></button>
                </p>
            </div>
        `;

            lastRow.insertAdjacentElement('afterend', newForm);

            const deleteButton = newForm.querySelector('.delete-form');
            deleteButton.addEventListener('click', function () {
              	countPackage = countPackage - 1;
                newForm.remove();
            });
        });
    
    }, []);
  
   const [selected, setSelected] = useState(packageToCountry !== null ? packageToCountry : "US");
  const onSelect = (code: string): void => setSelected(code);
    useEffect(() => {
    
  }, []); // <-- empty array means 'run once'
  
  
  //setSelected("us");
  if (listCountry.length === 0) {
    console.log("Fetch List Country");
    fetch('https://gw.vietlight-express.com/tracking/v1/country').then((response) => response.json()).then((data) => {
			if (Array.isArray(data.data)) {
                setCountry(data.data);
            }
       });
  }

const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);
        return {
            total,
            hours,
            minutes,
            seconds,
        };
    };


	const startTimer = (e) => {
        let { total, hours, minutes, seconds } = getTimeRemaining(e);
        if (total >= 0) {
		console.log("xxx");
            // update the timer
            // check if less than 10 then we need to
            // add '0' at the beginning of the variable
                setTimer(
                    (hours > 9 ? hours : "0" + hours) +
                    ":" +
                    (minutes > 9 ? minutes : "0" + minutes) +
                    ":" +
                    (seconds > 9 ? seconds : "0" + seconds));
		    
        }
    };

	const clearTimer = (e) => {
        // If you adjust it you should also need to
        // adjust the Endtime formula we are about
        // to code next
        setTimer("00:00:10");

        // If you try to remove this line the
        // updating of timer Variable will be
        // after 1000ms or 1sec
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000);
        Ref.current = id;
    };

    const getDeadTime = () => {
        let deadline = new Date();

        // This is where you need to adjust if
        // you entend to add more time
        deadline.setSeconds(deadline.getSeconds() + 10);
        return deadline;
    };

	useEffect(() => {
        clearTimer(getDeadTime());
    }, []);

	const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return <></>;
  } else {
    // Render a countdown
    return <span>{days} days {hours}:{minutes}:{seconds}</span>;
  }
};

  
  
  function handleSubmit(e) {
    console.log('clicked');
    /*
    if (pathRoute !== 'check-fare') {
      const form = e.target;
      const formData = new FormData(form);
      form.method = "GET";
      form.submit();
      return true;
    } else {
      e.preventDefault();
    }
    */
    e.preventDefault();
    
    let selectedCountry = 0;
    let listChina = [
      {"country_code":"CN1",
       "country_name":"China I"},
      {"country_code":"CN2",
       "country_name":"China II"},
    ]
    console.log(selected);
    if(selected === null) {
      selected = packageToCountry;
    }
    
    if (selected === "CN1" || selected === "CN2") {
      selectedCountry = listChina.find((element) => {
        return element.country_code === selected;
      })
      console.log(selectedCountry);
      selectedCountry = selectedCountry.country_name;
    }
    console.log(selectedCountry);
    let found = listCountry.find(obj => {
      return obj.country_code === selected;
    });
    
    console.log("List Country");
    console.log(listCountry);
    if (found === undefined) {
      found = listCountry.find(obj => {
        return obj.country_name === selectedCountry;
      });
    }
    if (found !== undefined) {
      selectedCountry = found.country_id;
    }
    
    const details = [
      {
        item_id: inputPackage.current.value,
        quantity: inputQuantity.current.value,
        length: inputLenght.current.value,
        width: inputWide.current.value,
        height: inputHeight.current.value,
        weight: inputWeight.current.value,
      },
    ];
    const nodeList = document.querySelectorAll("#formTemplate .row");
    for (let i = 2; i <= nodeList.length; i++) {
      if (document.querySelector('[name="quantity_'+i+'"]') !== null) {
        let quantity = document.querySelector('[name="quantity_'+i+'"]').value;
        let length = document.querySelector('[name="length_'+i+'"]').value;
        let width = document.querySelector('[name="width_'+i+'"]').value;
        let height = document.querySelector('[name="height_'+i+'"]').value;
        let weight = document.querySelector('[name="weight_'+i+'"]').value;
        details[i-1] = {
          item_id: inputPackage.current.value,
          quantity: quantity,
          length: length,
          width: width,
          height: height,
          weight: weight,
        };
      }
    }
console.log(inputDiscount.current.checked);
	  var discountChecked = inputDiscount.current.checked ? true : false;
  
     const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          from_country_id: 1,
          to_country_id: selectedCountry,
          area: inputLocation.current.value,
          details: details,
	  is_discount: discountChecked,
        })
    };
    fetch('https://gw.vietlight-express.com/tracking/v1/checking-price', requestOptions)
        .then(response => response.json())
        .then(data => {
          console.log('This is your data', data);
          setResultChecking(data);
       });
    
  }

   
  return (
    <div className="App">
    	<header><div>ABC</div></header>
    	
    
    
    <div class="team-area de-padding">
            <div class="container">
                                <div class="row">
                    <div class="col-xl-8 offset-xl-2">
                        <div class="site-title text-center">
                                                        <span class="hero-sub-title mb-20">
                                <span class="hero-line"></span>
                                CHECK FREIGHT FARE</span>
                                                                                    <h2 class="heading-1 mb-20">
                                Quickly Check Fare                           </h2>
                                                                                    <p class="mb-0">With simple steps, you can easily find freight fare to your desired destination on the Vietlight Express website.</p>
                                                    </div>
                    </div>
                </div>
                                <div class="team-wpr grid-3">
                                    </div>
            </div>
        </div>
    
    <form action={language !== '' ? "/" + language + "/check-fare/" : "/check-fare/"} method="post" onSubmit={handleSubmit}>
		<div class="quote-form">
    <div class="contact-form-requ">
        <div class="container row">
            <div class="col-md-4">
                <p><label for="loaihang"><b class="sectors">Package Type:</b></label><br />
                    <span class="wpcf7-form-control-wrap" data-name="packageType">
                      <select defaultValue={packageType} ref={inputPackage}
                            class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required form-control input-style-2 form-select"
                            id="loaihang" aria-required="true" aria-invalid="false" name="packageType">
                            <option value="1">Document</option>
                            <option value="2">Package</option>
                        </select>
                    </span>
                </p>
            </div>
            <div class="col-md-4">
                <p><label for="khuvuc"><b class="sectors">Area:</b></label><br />
                    <span class="wpcf7-form-control-wrap" data-name="area">
                        <select defaultValue={packageArea} ref={inputLocation} 
                            class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required form-control input-style-2 form-select"
                            id="khuvuc" aria-required="true" aria-invalid="false" name="area">
                            <option value="1">North</option>
                            <option value="2">Central region</option>
                            <option value="3">Southern</option>
                        </select>
                    </span>
                </p>
            </div>
            <div class="col-md-4">
                <p><label for="quocgia"><b class="sectors">To Country:</b></label><br />
                    <span class="wpcf7-form-control-wrap" data-name="toCountry">
                      <input type="hidden" name="toCountry" defaultValue={packageToCountry} value={selected} />
                      <div className="demo-wrapper">
                        
                        <ReactFlagsSelect
                          selected={selected}
                          onSelect={onSelect}
  							countries={listCountries}
                          showSelectedLabel={showSelectedLabel}
                          showSecondarySelectedLabel={showSecondarySelectedLabel}
                          selectedSize={selectedSize}
                          showOptionLabel={showOptionLabel}
                          showSecondaryOptionLabel={showSecondaryOptionLabel}
                          optionsSize={optionsSize}
                          placeholder={placeholder}
                          searchable={searchable}
                          searchPlaceholder={searchPlaceholder}
                          alignOptionsToRight={alignOptionsToRight}
                          fullWidth={fullWidth}
                          disabled={disabled}
                        />
                      </div>
                    </span>
                  </p>
              </div>
          </div>
          <p class="h-pack">Package 
          </p>
          <div id="formTemplate">
          <div class="row-list">
            <div class="row">
              <div class="col-sm-2">
                  <div class="form-group">
                      <p><label for="soluong"><b class="sectors-bot">Quantity</b></label><br />
                          <span class="wpcf7-form-control-wrap" data-name="quantity">
                            <input defaultValue={packageQuantity} ref={inputQuantity} class="wpcf7-form-control wpcf7-number wpcf7-validates-as-required wpcf7-validates-as-number form-control input-style-2" type="number" name="quantity_1" min="1" />
                            </span>
                      </p>
                  </div>
              </div>
              <div class="col-sm-2">
                  <div class="form-group">
                      <p><label for="dai"><b class="sectors-bot">Length (CM)</b></label><br />
                          <span class="wpcf7-form-control-wrap" data-name="length">
                            <input defaultValue={packageLength} ref={inputLenght} class="wpcf7-form-control wpcf7-number wpcf7-validates-as-required wpcf7-validates-as-number form-control input-style-2" type="number" name="length" min="1" /></span>
                      </p>
                  </div>
              </div>
              <div class="col-sm-2">
                  <div class="form-group">
                      <p><label for="rong"><b class="sectors-bot">Width (CM)</b></label><br/>
                          <span class="wpcf7-form-control-wrap" data-name="width">
                            <input defaultValue={packageWidth} ref={inputWide} class="wpcf7-form-control wpcf7-number wpcf7-validates-as-required wpcf7-validates-as-number form-control input-style-2" type="number" name="width" min="1" />
                          </span>
                      </p>
                  </div>
              </div>
              <div class="col-sm-2">
                  <div class="form-group">
                      <p><label for="cao"><b class="sectors-bot">Height (CM)</b></label><br />
                          <span class="wpcf7-form-control-wrap" data-name="height">
                            <input defaultValue={packageHeight} ref={inputHeight} class="wpcf7-form-control wpcf7-number wpcf7-validates-as-required wpcf7-validates-as-number form-control input-style-2" type="number" name="height" min="1" /></span>
                      </p>
                  </div>
              </div>
              <div class="col-sm-2">
                  <div class="form-group">
                      <p><label for="khoiluong"><b class="sectors-bot">Weight
                                  (KG)</b></label><br/>
                          <span class="wpcf7-form-control-wrap" data-name="weight">
                            <input defaultValue={packageWeight} ref={inputWeight} class="wpcf7-form-control wpcf7-number wpcf7-validates-as-required wpcf7-validates-as-number form-control input-style-2" type="number" name="weight" min="0.5" step="0.5" /></span>
                      </p>
                  </div>
              </div>
              
          </div>
            </div>
		<div class="add-btn-package">
          <div class="add-send">
              <p><span class="themhang" type="button" id="addBtn">+ ADD ITEM</span>
              </p>
          </div>
          <div class="contact-sub-btn">
	  	<p style={{display: "flex"}}>
	  		<input ref={inputDiscount} type="checkbox" name="is_discount" class="" style={{appearance: "auto"}} id="discountCheck" value="1" /> <label style={{ lineHeight: "40px",fontSize: "16px", padding: "0 30px 0 5px" }} for="discountCheck">Discount</label>
                  	<input class="wpcf7-form-control wpcf7-submit has-spinner btn-1n btn-md" id="checkfareBtn"
                          type="submit" value="CHECK FREIGHT" />
                  </p>
              </div>
		</div>
    </div>
</div>
</div>
    </form>




{!resultChecking || !Array.isArray(resultChecking) ? "" : resultChecking.map( d => (
	<div class=" w-10/12  pt-5 max-md:w-11/12 result-container ">
          <div class="flex w-full flex-col items-center justify-center">
            <div class="mt-4 flex w-full flex-col rounded-[12px] bg-white p-5 shadow-2xl">
			<div class="grid w-full grid-cols-2 gap-4 max-md:grid-cols-1">
  <div class="col-span-1">
  	<img src={d.logo_url} style={{width: '80%', margin: "0 auto"}} />
    
</div>
<div class="col-span-1 col-span-2">
  <h4>{d.service_name} || {d.transit_time}</h4>
	<p>Delivery expected<br/>
      <strong>{d.estimated_delivery_date}</strong> | No later than the end of the day or earlier</p>
    <p>Receive goods within 2 hours - 36 hours from the time of creating the order</p>
	<p style={{color: "lightgreen"}}>Price validity until {d.end_date}</p>
</div>

<div class="col-span-1">
  <p>Price from: 
	{ d.discount_value ? 
		(<><span style={{textDecoration: "line-through", paddingRight: "10px"}}>{d.value}</span><span style={{color: "red"}}>{d.discount_value} {d.currency} ({d.discount_percentage}%)</span></>)
	:
		(<>{d.value} {d.currency}</>)
	}
	</p>
	{ d.promotion_code ?
		<>
			<button class="themhang" type="button"><a href={"https://myvietlight.vietlight-express.com/#/apps/inbound/awb/create-for-cus?service_id="+d.service_id+"&promotion_code="+d.promotion_code+"&promotion_id="+d.promotion_id}>Continue booking services</a></button>
		</>
	:
		<>
			<button class="themhang" type="button"><a href={"https://myvietlight.vietlight-express.com/#/apps/inbound/awb/create-for-cus?service_id="+d.service_id}>Continue booking services</a></button>
		</>
	}
	{ d.promotion_code ?
		(<p>Mã giảm giá: {d.promotion_code}</p>)
		:
		(<></>)
	}
	{ d.remaining_time ?
                (<p>Thời gian còn lại: <Countdown
    date={Date.now() + d.remaining_time*1000}
    renderer={renderer}
  /></p>)
                :
                (<></>)
        }
	{ d.appliable_area ?
                (<p>{d.appliable_area}</p>)
                :
                (<></>)
        }
	</div>


</div></div></div></div>
        
        ))}
		
    </div>
  );
}


export default App;
